<template>
  <div class="input-group flex-nowrap">
    <input class="form-control" v-model="localModel" data-cy="search-txt" />
    <div class="input-group-append">
      <b-dropdown right>
        <b-dropdown-item-button @click="clear()" :disabled="!props.value">
          <Icon icon="Broom" class="mr-1" />
          {{ $t("Clear") }}
        </b-dropdown-item-button>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-header id="dropdown-header"> {{ $t("Users") }}</b-dropdown-header>
        <b-dropdown-item
          v-for="item in items"
          :key="item.userId"
          @click="onClick(item.name)"
          :active="props.value == item.name"
          v-b-tooltip.viewport.hover="item.name">
          {{ item.name }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { SelectionListModel } from "@medapro-types/AdvancedSearch/components/QueryBuilder";
import Icon from "@common/components/Icon.vue";
import { computed } from "vue";

//#region General
const { t: $t } = useI18n();
const props = withDefaults(defineProps<{ value: string; items?: Array<SelectionListModel> }>(), {
  items: () => []
});
const emits = defineEmits(["input"]);

function onClick(name: string) {
  emits("input", name);
}

function clear() {
  emits("input", "");
}
//#endregion

//#region Update localModal
const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});
//#endregion
</script>
